/* tslint:disable */
/* eslint-disable */
/**
 * Dialpad Contact API
 * API to fetch call center groups with specific filters.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface CustomIvr
 */
export interface CustomIvr {
  /**
   *
   * @type {number}
   * @memberof CustomIvr
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof CustomIvr
   */
  ivrType?: string;
  /**
   *
   * @type {string}
   * @memberof CustomIvr
   */
  text?: string;
  /**
   *
   * @type {string}
   * @memberof CustomIvr
   */
  mp3?: string;
  /**
   *
   * @type {string}
   * @memberof CustomIvr
   */
  name?: string;
  /**
   *
   * @type {number}
   * @memberof CustomIvr
   */
  dateAdded?: number;
  /**
   *
   * @type {string}
   * @memberof CustomIvr
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof CustomIvr
   */
  url?: string;
  /**
   *
   * @type {boolean}
   * @memberof CustomIvr
   */
  localized?: boolean;
  /**
   *
   * @type {{ [key: string]: { [key: string]: string; }; }}
   * @memberof CustomIvr
   */
  ivr?: { [key: string]: { [key: string]: string } };
}

/**
 * Check if a given object implements the CustomIvr interface.
 */
export function instanceOfCustomIvr(value: object): value is CustomIvr {
  if (!('id' in value) || value['id'] === undefined) return false;
  return true;
}

export function CustomIvrFromJSON(json: any): CustomIvr {
  return CustomIvrFromJSONTyped(json, false);
}

export function CustomIvrFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomIvr {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    ivrType: json['ivr_type'] == null ? undefined : json['ivr_type'],
    text: json['text'] == null ? undefined : json['text'],
    mp3: json['mp3'] == null ? undefined : json['mp3'],
    name: json['name'] == null ? undefined : json['name'],
    dateAdded: json['date_added'] == null ? undefined : json['date_added'],
    description: json['description'] == null ? undefined : json['description'],
    url: json['url'] == null ? undefined : json['url'],
    localized: json['localized'] == null ? undefined : json['localized'],
    ivr: json['ivr'] == null ? undefined : json['ivr'],
  };
}

export function CustomIvrToJSON(value?: CustomIvr | null): any {
  if (value == null) {
    return value;
  }
  return {
    id: value['id'],
    ivr_type: value['ivrType'],
    text: value['text'],
    mp3: value['mp3'],
    name: value['name'],
    date_added: value['dateAdded'],
    description: value['description'],
    url: value['url'],
    localized: value['localized'],
    ivr: value['ivr'],
  };
}
